/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="./search_interfaces.ts"/>
/// <reference path="./solr_search.ts"/>
/// <reference path="./solr_search_collection.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export class DealerwareSolrSearchEmployeeCollection
        extends DealerwareCollectionSolrSearch
        implements IDealerwareSolrSearchEmployeeCollection {


        public static $inject: string[] = [
            'DealerwareEmployeeCollection',
            '$q',
            '$timeout',
            '$dealerwareEmployeeStatesData',
            '$dealerwareSearchAliases'
        ];

        constructor(
            public DealerwareEmployeeCollection : any,
            public $q : any,
            public $timeout : any,
            public DealerwareEmployeeStatesData: any,
            public dealerwareSearchAliases: any
        ) {

            super($q,$timeout);
            this.objectCollection = DealerwareEmployeeCollection;

            this.dealerwareSearchAliases.aliasData = this.DealerwareEmployeeStatesData.states;

            var allFilter = new DealerwareSolrSearchSmartFilter();
            allFilter.name = "all";
            allFilter.displayDescription = "Find all employees";
            allFilter.searchProperty = "all";
            allFilter.filters = this.dealerwareSearchAliases.getAliasedItems(allFilter.name);
            allFilter.displayTitleIcon = 'filter';

            this.searchFilters.add(allFilter);
        }
    }

    getDealerwareWebServicesModule().service("$dealerwareSolrSearchEmployeeCollection", DealerwareSolrSearchEmployeeCollection);
}